import React, { useState } from "react";
import TooltipButton from "../components/Tools/TooltipButton.tsx";
import { FaRegTrashAlt } from "react-icons/fa";
import { FaTrash, FaTimes, FaExclamationTriangle } from "react-icons/fa";
import { Spinner } from "react-bootstrap";

interface request {
    title: string,
    deleteAPI: (row: any, afterDelete: any) => void,
    nameFieldId: string,
    row: any
}
export function DeleteRowButton({ title, deleteAPI, nameFieldId, row }: request) {
    const [deleteCandidate, setDeleteCandidate] = useState<any | null>(null);
    const [deleting, setDeleting] = useState(false);

    return (
        <>

            {
                deleting ?
                    <TooltipButton title={`Deleting ${title}`}>
                        <button
                            className='btn btn-outline-danger py-1 px-2 m-0 border-0'>
                            <Spinner size="sm" />
                        </button>
                    </TooltipButton> :
                    <TooltipButton title={`Delete ${title}`}>
                        <button
                            className='btn btn-outline-danger py-1 px-2 m-0 border-0 joy_del'
                            onClick={(e) => {
                                e.stopPropagation();
                                setDeleteCandidate((typeof row.original != 'undefined') ? row.original : row);
                            }}
                        >
                            <FaRegTrashAlt />
                        </button>
                    </TooltipButton>
            }
            {deleteCandidate && (
                <div
                    className="modal fade show"
                    style={{
                        display: 'block',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        transition: 'opacity 0.3s ease-in-out'
                    }}
                    tabIndex={-1}
                    role="dialog"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content animate__animated animate__fadeInDown">
                            <div className="modal-header fw-bold">
                                <h5 className="modal-title d-flex align-items-center gap-2">
                                    <FaTrash />
                                    Confirm Deletion
                                </h5>
                                <button type="button" className="btn-close btn-close" onClick={(e) => {
                                    e.stopPropagation();
                                    setDeleteCandidate(null);
                                }}></button>
                            </div>
                            <div className="modal-body text-center">
                                <FaExclamationTriangle size={40} color="#dc3545" className="mb-3" />
                                <p className="fs-6 text-secondary text-break">Are you sure you want to delete the {title} <strong>{deleteCandidate[nameFieldId]}</strong>?</p>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-outline-secondary d-flex align-items-center gap-1" onClick={(e) => {
                                    e.stopPropagation();
                                    setDeleteCandidate(null);
                                }}>
                                    <FaTimes />
                                    Cancel
                                </button>
                                <button className="btn btn-danger d-flex align-items-center gap-1" onClick={(e) => {
                                    e.stopPropagation();
                                    setDeleting(true);
                                    deleteAPI(row, () => {
                                        setDeleting(false);
                                    });
                                    // // Call delete API here
                                    // console.log("Deleting", deleteCandidate.roleGroupID);
                                    // // Fake delete and refresh
                                    // setGroups(prev => prev?.filter(g => g.roleGroupID !== deleteCandidate.roleGroupID) || []);
                                    setDeleteCandidate(null);
                                }}>
                                    <FaTrash />
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default DeleteRowButton;